export const hotelBedSizeType: any = {
  single: "Single",
  double: "Double",
  queen: "Queen",
  king: "King",
};
